import { store } from '../store';
import { refreshAuthentication } from '../store/slices/authSlice';

function getAdminToken(): string {
  return store.getState().auth.token || '';
}

/**
 * Admin API fetch with one automatic JWT refresh + retry on 401.
 * Raw fetch bypasses axios interceptors — use this for all admin Bearer-token calls.
 */
export async function adminAuthenticatedFetch(
  url: string,
  init: RequestInit = {},
  timeoutMs = 20000
): Promise<Response> {
  const run = async (): Promise<Response> => {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), timeoutMs);
    try {
      const headers = new Headers(init.headers);
      const token = getAdminToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return await fetch(url, { ...init, headers, signal: controller.signal });
    } catch (err: any) {
      if (err?.name === 'AbortError' || controller.signal.aborted) {
        throw new Error(`Request timed out after ${Math.round(timeoutMs / 1000)}s. Please try again.`);
      }
      throw err;
    } finally {
      window.clearTimeout(timer);
    }
  };

  let response = await run();
  if (response.status === 401) {
    const refresh = await store.dispatch(refreshAuthentication());
    if (refresh.meta.requestStatus === 'fulfilled') {
      response = await run();
    }
  }
  return response;
}
